import OrganisationsContainer  from "./container/OrganisationsContainer"
// Sync route definition
export default {
  path: '/organisations',
  component : OrganisationsContainer,
  exact: true,
}
